import { gql } from '@apollo/client'

export const USER_TABLE_COLUMN_SETTINGS = gql`
  query UserTableColumnSettings($tableId: String!) {
    userTableColumnSettings(tableId: $tableId) {
      tableId
      tenantHiddenColumns
      userHiddenColumns
      effectiveHiddenColumns
    }
  }
`
